<app-toast [message]="toast.message"></app-toast>

<div class="row">
  <div class="col-2 ps-0 sidebar">
    <app-sidebar [items]="menuItems" [current]="currentContent"></app-sidebar>
  </div>
  <div class="col-10 px-0">
    <div class="card">
      <h4 class="card-header">Reset password</h4>
      <div class="card-body">
        <app-reset-password-form></app-reset-password-form>
      </div>
    </div>
  </div>
</div>